import {createAction, props} from "@ngrx/store";
import {Serializers} from "../../interfaces/serializer";
import {DataSource} from "../../interfaces/data-source";

export const loadDataSourcesAll = createAction('[DATA_SOURCES_ALL] LOAD');
export const loadDataSourcesAllSuccess = createAction(
  '[DATA_SOURCES_ALL] LOAD_SUCCESS',
  props<{ dataSources: Serializers<DataSource> }>()
);
